<template>
    <b-card-code title="Cari Data">
      <slot />
    </b-card-code>
</template>

<script>
import BCardCode from "@core/components/b-card-code/BCardCode.vue";

export default {
  components: {
    BCardCode,
  },
}

</script>